import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataCaptureService } from 'src/app/modules/data-capture/services/data-capture.service';
import {
  CONSUMER_CP_QP_NOMINATION_URL,
  CONSUMER_MANAGE_WORKFLOWS_URL,
  CONSUMER_REPORTING_WORKFLOW_URL,
  CP_QP_NOMINATION_URL,
} from '../../constants/constant';

@Component({
  selector: 'app-group-card',
  templateUrl: './group-card.component.html',
  styleUrls: ['./group-card.component.scss'],
})
export class GroupCardComponent implements OnInit {
  @Input() public groupCardHeader: string;
  @Input() public groupCardWidth: any;
  @Input() public showToggleIcon = false;
  @Input() public redirectUrl: string;
  @Input() public headerIcon: string;
  @Input() public hierarchyLevel: any;
  @Input() public chartType: string;
  @Input() public depositID: number;
  @Input() public tooltipText: string;
  public isUserRoleConsumer = false;

  public showCards = true;
  constructor(private router: Router , private dataCaptureService: DataCaptureService ) {}

  public ngOnInit(): void {
    this.isUserRoleConsumer = this.dataCaptureService.getConsumerRoleType();

  }

  public toggle(): void {
    // this.showCards = !this.showCards;
  }

  public onClick() {
    if (this.redirectUrl) {
      if (this.hierarchyLevel === 3 ) {
        if (this.router.url.indexOf(CP_QP_NOMINATION_URL) > -1) {
          this.router.navigateByUrl(
            `${this.redirectUrl}/${CONSUMER_CP_QP_NOMINATION_URL}`
          );
        }
          else {
        this.router.navigateByUrl(
          `${this.redirectUrl}/${CONSUMER_REPORTING_WORKFLOW_URL}`
        );
        }
      } else if(this.hierarchyLevel !== 3) {
        this.router.navigateByUrl(this.redirectUrl);
      }
    }
  }
}
